import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import imageNotFound from 'src/images/imageNotFound.png'
import { catalogDeps } from 'src/deps'
import {
  application,
  getImageFromProperty,
  i18nTranslate,
  enablePdpRedesign,
  enableNewFeature,
  trackPathToPurchaseSelectItem,
  setLocalStorage,
} from 'src/utils'
import { BUNDLE_PRODUCT, KIT_PRODUCT } from 'src/utils/constant'
import { Dropdown } from 'react-bootstrap'
import { builder } from 'src/models/Catalog/builder'
import debounce from 'lodash/debounce'
import { cartContainer, accountsContainer } from 'src/models'
import { closeIcon, dropdownIcon } from './fixture'
import './styles.scss'
import { productStatusDeps } from 'src/views/components/ProductComponents/V2ProductQuantityAndButtons/ProductStatusDeps'

@observer
class PlpBundleOrKitSelectOptions extends React.Component {
  @observable selectedVariantValue = {}

  constructor(props) {
    super(props)
    this.initializeFromPreviousSelection()
  }

  componentDidUpdate(prevProps) {
    // Re-initialize if previously selected variants change (e.g., user changed selection)
    if (
      prevProps.previouslySelectedBundleVariants !==
      this.props.previouslySelectedBundleVariants
    ) {
      this.initializeFromPreviousSelection()
    }
  }

  initializeFromPreviousSelection = () => {
    const { previouslySelectedBundleVariants } = this.props
    // Only initialize if we have previous selections (POAdmin restoration scenario)
    if (
      previouslySelectedBundleVariants &&
      Array.isArray(previouslySelectedBundleVariants)
    ) {
      const initializedVariants = {}
      previouslySelectedBundleVariants.forEach(variant => {
        if (variant.productId && variant.skuId) {
          initializedVariants[variant.productId] = {
            selectedSku: variant.skuId,
            selectedVariant: variant.variantLabel || '',
          }
        }
      })
      this.selectedVariantValue = initializedVariants
    }
  }

  handleBundleSelect = () => {
    const {
      bundleMandatoryProducts = [],
      skuKit = [],
      type = 'DEFAULT',
    } = this.props?.productResponse?.product?.[0] || {}
    const subProducts =
      type === BUNDLE_PRODUCT ? bundleMandatoryProducts : skuKit

    // Collect selected variants
    const selectedVariants =
      subProducts?.map(mandatoryProduct => {
        const isVariantSelected =
          this.selectedVariantValue?.hasOwnProperty(
            mandatoryProduct?.identifier
          ) &&
          this.selectedVariantValue?.[mandatoryProduct?.identifier]?.selectedSku
        const defaultSku = isVariantSelected
          ? catalogDeps.getSelectedSkuById(
              mandatoryProduct,
              this.selectedVariantValue?.[mandatoryProduct?.identifier]
                ?.selectedSku
            )?.[0] || {}
          : catalogDeps.getDefaultSelectedSku(mandatoryProduct, type)?.[0] || {}
        return {
          productId: mandatoryProduct?.identifier || '',
          productName: mandatoryProduct?.properties?.name || '',
          skuId: defaultSku?.identifier || '',
          skuName: defaultSku?.properties?.name || '',
          quantity: mandatoryProduct?.properties?.quantity || 1,
          variantLabel: defaultSku?.properties?.variantLabel || '',
        }
      }) || []

    return selectedVariants
  }

  handleAddToCart = async () => {
    // For POAdmin, handle selection instead of add to cart
    if (this.props?.isPOAdminScreen && this.props?.onBundleSelect) {
      const selectedVariants = this.handleBundleSelect()
      const productIdentifier =
        this.props?.productResponse?.product?.[0]?.identifier || ''
      return this.props.onBundleSelect({
        productId: productIdentifier,
        selectedVariants: selectedVariants,
      })
    }
    setLocalStorage('isExpressCart', false)

    const postData = {
      quantity: 1,
    }
    const {
      bundleMandatoryProducts = [],
      skuKit = [],
      identifier = '',
      type = 'DEFAULT',
      properties: {
        availableChannels = '',
        scanQualifiedCount = 0,
        name = '',
        slug = '',
      },
    } = this.props?.productResponse?.product?.[0] || {}
    const productType =
      type === KIT_PRODUCT ? skuKit?.[0]?.type : type || 'DEFAULT'

    cartContainer.addToCartClickedProductDetails =
      this.props?.productResponse?.product || []

    postData['skus'] = [
      {
        productId: identifier,
        skuId: identifier,
        type: productType?.toUpperCase(),
        availableChannels,
      },
    ]
    const mandatoryProducts =
      type === BUNDLE_PRODUCT ? bundleMandatoryProducts : skuKit

    let isBundleBackOrdered = false
    mandatoryProducts?.forEach(mandatoryProduct => {
      const isVariantSelected =
        this.selectedVariantValue?.hasOwnProperty(
          mandatoryProduct?.identifier
        ) &&
        this.selectedVariantValue?.[mandatoryProduct?.identifier]?.selectedSku
      const defaultSku = isVariantSelected
        ? catalogDeps.getSelectedSkuById(
            mandatoryProduct,
            this.selectedVariantValue?.[mandatoryProduct?.identifier]
              ?.selectedSku
          )?.[0] || {}
        : catalogDeps.getDefaultSelectedSku(mandatoryProduct, type)?.[0] || {}
      postData['skus'].push({
        productId: mandatoryProduct?.identifier || '',
        skuId: defaultSku?.identifier || '',
        type: 'MANDATORY',
        skuQuantity: mandatoryProduct?.properties?.quantity || 1,
        availableChannels: defaultSku?.properties?.availableChannels || '',
        backOrdered: defaultSku?.inventoryProperties?.backOrdered || false,
      })
      if (
        !isBundleBackOrdered &&
        defaultSku?.inventoryProperties?.backOrdered == true
      )
        isBundleBackOrdered = true
    })

    postData['properties'] = {
      categoryId:
        this.props?.productResponse?.category?.name ||
        this.props?.productResponse?.category?.identifier ||
        '',
      listName:
        this.props?.productResponse?.category?.parentId ||
        this.props?.productResponse?.searchTerm ||
        '',
      slug,
      scanQualifiedCount: Number(scanQualifiedCount || 0),
      isBackOrdered: isBundleBackOrdered,
      name,
      productId: identifier,
      price: this.props?.productResponse?.product[0]?.prices[0]?.price || '',
    }
    const isToShowViewCartButton = true
    let source = 'plp-product-card'
    let isFromPLP = this.props.isFromCatalog || false
    if (this.props?.isSubscriptionOnly) {
      postData.subscription = {
        frequencyPeriod: '1',
        frequencyType: 'MONTHS',
        type: 'VARIABLE_MULTI_ORDER',
      }
      postData.isSubscription = true
    }
    await cartContainer.addToCartFromViewCart(
      [postData],
      source,
      isToShowViewCartButton,
      false,
      true,
      isFromPLP
    )
    this.handleCancelSelectOptionsClick()
  }

  renderSelectOptions = (
    variantTypeValues,
    productId,
    defaultVariantId,
    defaultVariantLabel,
    product,
    itemIndex
  ) => {
    const showVariantDropdown =
      Array.isArray(variantTypeValues) && variantTypeValues?.length > 0
    const selectedVariant = this.selectedVariantValue?.[productId]?.selectedSku
      ? this.selectedVariantValue?.[productId]?.selectedSku
      : defaultVariantId
    const items = showVariantDropdown ? (
      variantTypeValues?.map(item => {
        const isSelectedClass =
          item.identifier === selectedVariant ? 'selected' : ''
        return (
          <Dropdown.Item
            as="button"
            key={item?.label}
            value={item?.identifier}
            className={isSelectedClass}
            onClick={debounce(event => {
              this.handleVariantSelection(product, item, itemIndex)
            }, 700)}
            onKeyPress={debounce(event => {
              this.handleVariantSelection(product, item, itemIndex)
            }, 700)}
            data-testid="qa-pdp-select-option-label">
            {item.label}
          </Dropdown.Item>
        )
      })
    ) : (
      <></>
    )
    if (!showVariantDropdown) {
      return <></>
    }
    return (
      <div className="pdp-select-option">
        <span className="pdp-select-option-dropdown-title">
          {i18nTranslate('product.selectOption', 'Select your option', {
            nameSpace: 'ssr-resource',
          }) + ': '}
        </span>
        <Dropdown
          className="pdp-select-option-dropdown"
          data-testid="qa-pdp-select-option-dropdown"
          drop="up">
          <Dropdown.Toggle
            className="d-flex pdp-select-option-dropdown-toggle text-left"
            variant="light">
            <div className="pdp-select-option-dropdown-left-section">
              <span
                className="pdp-select-option-dropdown-value"
                data-testid="qa-pdp-select-option-value">
                {this.selectedVariantValue?.[productId]?.selectedVariant ||
                  defaultVariantLabel}
              </span>
            </div>
            <div className="dropdown-right-section">{dropdownIcon()}</div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="pdp-select-option-dropdownmenu">
            {items}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    )
  }

  handleVariantSelection = (product = {}, item = {}, itemIndex = 0) => {
    const productId = product?.identifier || ''
    this.selectedVariantValue[productId] = {
      selectedSku: item?.identifier,
      selectedVariant: item?.label,
    }

    const mainProduct = this.props?.productResponse?.product?.[0] || {}

    if (this.props?.isPOAdminScreen && this.props?.onBundleSelect) {
      const selectedVariants = this.handleBundleSelect()

      if (this.props?.triggerBundlePromotionCall) {
        this.props.triggerBundlePromotionCall({
          productId: mainProduct?.identifier || '',
          selectedVariants: selectedVariants,
        })
      }
    }

    if (!enableNewFeature('enableGTMSelectItemEvent')) {
      return
    }

    const categoryName =
      this.props?.productResponse?.category?.name ||
      this.props?.productResponse?.category?.identifier ||
      ''
    const rawIndex =
      this.props?.index ?? this.props?.productIndex ?? this.props?.position ?? 0
    const sponsorId =
      typeof accountsContainer?.getUserTypeSponsorId === 'function'
        ? accountsContainer.getUserTypeSponsorId()
        : ''

    trackPathToPurchaseSelectItem({
      product: mainProduct,
      baseProduct: mainProduct,
      itemListName: categoryName || 'all products',
      itemIndex: rawIndex,
      sponsorId,
      categoryName,
      selectedVariantLabel: item?.label || '',
    })
  }

  renderSubProducts = (product, index) => {
    const { identifier } = product || {}
    const { type = 'DEFAULT' } = this.props?.productResponse?.product?.[0] || {}
    const isVariantSelected =
      this.selectedVariantValue?.[identifier]?.selectedSku || false
    const defaultSku = isVariantSelected
      ? catalogDeps.getSelectedSkuById(
          product,
          this.selectedVariantValue?.[identifier]?.selectedSku
        )
      : catalogDeps.getDefaultSelectedSku(product, type)
    const imageUrl = getImageFromProperty(defaultSku?.[0]?.properties)
    const name = defaultSku?.[0]?.properties?.name || product?.properties?.name
    const skuId = defaultSku?.[0]?.identifier || ''

    const productOptions =
      product?.sku?.length > 1
        ? builder.getUniqueProductOptions(product?.sku)
        : []
    const variantLabel = productOptions?.filter(
      optionsAray => optionsAray?.type === 'variantLabel'
    )
    const variantTypeValues = variantLabel?.[0]?.values || []
    const defaultVariantLabel =
      defaultSku && defaultSku?.length
        ? defaultSku?.[0]?.properties?.variantLabel || ''
        : ''

    return (
      <div className="plp-sub-product" key={index}>
        <div className="plp-sub-product-details">
          <div className="plp-sub-product-image">
            <img src={imageUrl} alt="plp sub-product image" />
          </div>
          <div className="plp-sub-product-name">
            {name} <br />
            {enablePdpRedesign() && (
              <span className="quantity-text-count-label">
                {i18nTranslate('bundle.fixedQuantityTitle', 'Quantity', {
                  nameSpace: 'ssr-resource',
                })}
                {':'}
                <span className="quantity-text-count">
                  {product?.properties?.quantity || product?.quantity || '1'}
                </span>
              </span>
            )}
          </div>
        </div>
        {this.renderSelectOptions(
          variantTypeValues,
          identifier,
          skuId,
          defaultVariantLabel,
          product,
          index
        )}
      </div>
    )
  }

  handleCancelSelectOptionsClick = identifier => {
    const currentPlpCardItem = document.querySelectorAll(
      `.product_card_${identifier}`
    )
    currentPlpCardItem.forEach(item => {
      item.classList.remove('selectOptionClicked')
    })
    if (application?.isMobile) {
      document.body.classList.remove('overflow-hidden')
    }

    if (this.props.handleCancelSelectOptionsClick) {
      this.props.handleCancelSelectOptionsClick()
    }
  }

  get isAddToCartDisabled() {
    const product = JSON.parse(
      JSON.stringify(this.props?.productResponse?.product?.[0] || {})
    )
    const {
      bundleMandatoryProducts = [],
      skuKit = [],
      type = 'DEFAULT',
    } = product
    const subProducts =
      type === BUNDLE_PRODUCT ? bundleMandatoryProducts : skuKit
    subProducts.forEach(subProduct => {
      const identifier = subProduct?.identifier
      const selectedSkuId = this.selectedVariantValue?.[identifier]?.selectedSku
      if (selectedSkuId) {
        const selectedSkuArr = catalogDeps.getSelectedSkuById(
          subProduct,
          selectedSkuId
        )
        if (selectedSkuArr && selectedSkuArr.length > 0) {
          subProduct.selectedSku = selectedSkuArr[0]
        }
      } else {
        const defaultSkuArr = catalogDeps.getDefaultSelectedSku(subProduct, type)
        if (defaultSkuArr && defaultSkuArr.length > 0) {
          subProduct.selectedSku = defaultSkuArr[0]
        }
      }
    })
    const result =
      productStatusDeps.getBundleKitProductLevelInventoryStatus(product)
    return result?.disableBundleKitOneTime === true
  }

  render() {
    const {
      bundleMandatoryProducts = [],
      skuKit = [],
      identifier = '',
      type = 'DEFAULT',
    } = this.props?.productResponse?.product?.[0] || {}
    const subProducts =
      type === BUNDLE_PRODUCT ? bundleMandatoryProducts : skuKit

    return (
      <div className="plp-bundle-select-container">
        <div className="plp-select-option-wrapper">
          {application?.isMobile && (
            <button
              type="button"
              className="plp-select-close"
              aria-label={i18nTranslate('icons.close', 'close icon', {
                nameSpace: 'ssr-resource',
              })}
              onClick={() => this.handleCancelSelectOptionsClick(identifier)}>
              {closeIcon()}
            </button>
          )}
          <div className="plp-select-custom-option">
            {i18nTranslate(
              'category_page.selectCustomOption',
              'Select custom options',
              {
                nameSpace: 'ssr-resource',
              }
            ) + (!application?.isMobile ? ': ' : '')}
          </div>
          <div className="plp-subproduct-container">
            {subProducts?.map((product, index) => {
              return this.renderSubProducts(product, index)
            })}
          </div>
          <div className="btn-container">
            <button
              type="button"
              className="btn btn-primary add-cart-btn"
              onClick={() => this.handleAddToCart()}
              onKeyPress={() => this.handleAddToCart()}
              disabled={
                !this.props.isAddToCartButtonEnabled || this.isAddToCartDisabled
              }
              data-testid="qa-plp-bundle-select-add-button">
              {this.props?.isPOAdminScreen
                ? i18nTranslate('product.select', 'Select', {
                    nameSpace: 'ssr-resource',
                  })
                : i18nTranslate('addToCart', 'Add to cart', {
                    nameSpace: 'ssr-resource',
                  })}
            </button>
            <button
              type="button"
              className="btn btn-light cancel-btn"
              onClick={() => this.handleCancelSelectOptionsClick(identifier)}
              onKeyPress={() => this.handleCancelSelectOptionsClick(identifier)}
              data-testid="qa-plp-select-cancel-button">
              {i18nTranslate('search.cancel', 'Cancel', {
                nameSpace: this.nameSpace,
              })}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export { PlpBundleOrKitSelectOptions }
export default PlpBundleOrKitSelectOptions
